function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  clipRule: "evenodd",
  d: "M12 0C5.383 0 0 5.383 0 12c0 6.618 5.383 12 12 12s12-5.382 12-12c0-6.617-5.383-12-12-12zm0 21.6c-5.293 0-9.6-4.307-9.6-9.6 0-5.293 4.307-9.6 9.6-9.6 5.293 0 9.6 4.307 9.6 9.6 0 5.293-4.307 9.6-9.6 9.6zm-1.046-3.829L6.14 12.958l2.104-2.104 2.33 2.328 4.93-6.903 2.423 1.73-6.973 9.762z"
});

var SvgCheckCircleOutlined = function SvgCheckCircleOutlined(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), _ref);
};

export default __webpack_public_path__ + "44b247bb4367011aaa40fddc8638a110.svg";
export { SvgCheckCircleOutlined as ReactComponent };


//////////////////
// WEBPACK FOOTER
// ../icons/svg/check-circle-outlined.svg
// module id = null
// module chunks = 